import { render, staticRenderFns } from "./ShopCategory.vue?vue&type=template&id=238a8058&scoped=true&"
import script from "./ShopCategory.vue?vue&type=script&lang=js&"
export * from "./ShopCategory.vue?vue&type=script&lang=js&"
import style0 from "./ShopCategory.vue?vue&type=style&index=0&id=238a8058&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a8058",
  null
  
)

export default component.exports